<template>
  <section
    class="top-navbar"
    :style="`background: ${loginPageColor} !important;`"
  >
    <span
      v-if="
        this.companyDataLocal &&
        this.companyDataLocal.session_info &&
        this.companyDataLocal.session_info.timeOut &&
        this.companyDataLocal.session_info.appuser
      "
    >
      <v-idle
        style="display: none"
        @idle="onIdle"
        @remind="onRemind"
        :loop="true"
        :reminders="[60, 90]"
        :wait="10"
        :duration="this.companyDataLocal.session_info.timeOutSeconds * 60"
        :events="events"
      />
    </span>
    <div>
      <el-row type="flex" align="middle">
        <el-col :span="4">
          <div class="top-navbar-left-menu">
            <ul v-if="getIsMobile">
              <li>
                <div class="toggle-menu-animation">
                  <div
                    id="burger"
                    :class="{ active: getIsOpen }"
                    @click="sendMessageToParent"
                  >
                    <button type="button" class="burger-button" title="Menu">
                      <span class="hidden">Toggle menu</span>
                      <span class="burger-bar burger-bar--1"></span>
                      <span class="burger-bar burger-bar--2"></span>
                      <span class="burger-bar burger-bar--3"></span>
                    </button>
                  </div>
                </div>
              </li>
              <li>
                <div class="company-logo">
                  <a href="/ap/dashboard">
                    <img
                      v-if="this.companyDataLocal.logo"
                      :src="this.companyDataLocal.logo"
                      alt="Nimble logo"
                      style="max-height: 34px; max-width: 150px"
                    />
                  </a>
                </div>
              </li>
            </ul>
            <ul v-else>
              <li>
                <div class="company-logo">
                  <a href="/ap/dashboard">
                    <img
                      v-if="this.companyDataLocal.logo"
                      :src="this.companyDataLocal.logo"
                      alt="Nimble logo"
                      style="max-height: 34px; max-width: 150px"
                    />
                  </a>
                </div>
              </li>
              <li>
                <div class="toggle-menu-animation">
                  <div
                    id="burger"
                    :class="isOpen ? 'active' : ''"
                    @click="sendMessageToParent"
                  >
                    <button type="button" class="burger-button" title="Menu">
                      <span class="hidden">Toggle menu</span>
                      <span class="burger-bar burger-bar--1"></span>
                      <span class="burger-bar burger-bar--2"></span>
                      <span class="burger-bar burger-bar--3"></span>
                    </button>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </el-col>

        <el-col :span="20">
          <div class="top-navbar-right-menu">
            <ul class="logout-dropdown">
              <li
                v-if="!getIsMobile"
                :class="getIsMobile ? 'workspace' : 'workspace mr-1'"
              >
                <el-select
                  v-model="activeWorkspace"
                  placeholder="switch Workspace"
                  @change="changeWorkspaceRole"
                  :size="getIsMobile ? 'mini' : ''"
                  :style="getIsMobile ? 'float: right; width: 50%' : ''"
                >
                  <el-option
                    v-for="contact in getLoginContactTypes"
                    :key="contact._id"
                    :label="getName(contact.contact_type)"
                    :value="contact.contact_type._id"
                  ></el-option>
                </el-select>
              </li>
              <!-- <li
                v-else
                ref="workspaceRoleDropdown"
                class="notification-wrapper dropdown-trigger"
                @click="toggleWorkspaceRoleDropdown"
              >
                <div class="icon-block">
                  <div class="icon user-image">
                    <i
                      class="fa fa-building animated-icon"
                      style="font-size: 25px; color: white; margin-right: 5px"
                    ></i>
                  </div>
                </div>
                <div v-if="showWorkspaceRoleDropdown" class="custom-dropdown">
                  <div
                    v-for="contact in getLoginContactTypes"
                    :key="contact._id"
                    class="dropdown-option"
                    :class="{
                      'active-option':
                        activeWorkspace === contact.contact_type._id,
                    }"
                    @click.stop="selectWorkspaceRole(contact)"
                  >
                    {{ getName(contact.contact_type) }}
                  </div>
                </div>
              </li> -->
              <li>
                <el-dropdown trigger="click">
                  <el-button>
                    <div class="icon-block">
                      <div class="icon user-image profile-image">
                        <img
                          v-if="getAuthenticatedUser?.avatar?.length > 20"
                          :src="getAuthenticatedUser.avatar"
                          alt="user-image"
                          class="img-fluid"
                        />
                        <img
                          v-else
                          src="@/assets/img/avatar.svg"
                          alt="user-image"
                          class="img-fluid"
                        />
                      </div>
                      <div class="icon-text" v-if="!getIsMobile">
                        {{ getAuthenticatedUser | getUserFullName }}
                        <span class="el-icon-arrow-down text-white"></span>
                      </div>
                      <div class="icon-text" v-else>
                        <div class="circle-name">
                          {{ getAuthenticatedUser | getUserFullNameShortened }}
                        </div>
                      </div>
                    </div>
                  </el-button>

                  <el-dropdown-menu
                    slot="dropdown"
                    class="mobile-dropdown-menu"
                    v-if="getIsMobile"
                  >
                    <div class="dropdown-profile-block">
                      <div class="circle-name">
                        {{ getAuthenticatedUser | getUserFullNameShortened }}
                      </div>
                      <div class="profile-name-block">
                        <div class="full-name">
                          {{ getAuthenticatedUser | getUserFullName }}
                        </div>
                        <div class="active-workspace">
                          <i class="fa fa-building" style="margin-right: 5px" />
                          {{
                            getLoginContactTypes.find(
                              (e) => e.contact_type._id === activeWorkspace
                            )?.contact_type?.name || "Workspace"
                          }}
                        </div>
                      </div>
                    </div>

                    <div class="workspace-dropdown-container">
                      <label class="workspace-label">Switch Workspace</label>
                      <el-select
                        v-model="activeWorkspace"
                        placeholder="Select Workspace"
                        @change="changeWorkspaceRole"
                        size="small"
                        class="workspace-select"
                      >
                        <el-option
                          v-for="contact in getLoginContactTypes"
                          :key="contact._id"
                          :label="getName(contact.contact_type)"
                          :value="contact.contact_type._id"
                        />
                      </el-select>
                    </div>

                    <el-dropdown-item @click.native="openProfile">
                      <i class="fa fa-user-circle" style="margin-right: 8px" />
                      Profile
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="logoutUser">
                      <i class="el-icon-switch-button" />
                      Logout
                    </el-dropdown-item>
                  </el-dropdown-menu>

                  <el-dropdown-menu slot="dropdown" style="width: 125px" v-else>
                    <a @click="openProfile">
                      <el-dropdown-item>
                        <i
                          class="fa fa-user-circle"
                          style="margin-right: 6px"
                        />
                        Profile
                      </el-dropdown-item>
                    </a>
                    <a @click="logoutUser">
                      <el-dropdown-item>
                        <i class="el-icon-switch-button" />
                        Logout
                      </el-dropdown-item>
                    </a>
                  </el-dropdown-menu>
                </el-dropdown>
              </li>
            </ul>
          </div>
        </el-col>
      </el-row>
    </div>
    <footer
      v-if="getIsMobile"
      class="app-footer"
      :style="`background: ${loginPageColor} !important;`"
    ></footer>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import Swal from "sweetalert2";
import config from "../../config/app";
import UserHelper from "@/mixins/UserHelper";
import chroma from "chroma-js";
import { clearDB } from "@/repo/appSettingRepo";

export default {
  name: "ApplicationUserTopbar",
  data() {
    return {
      isOpen: "",
      isCollapse: "",
      loading: false,
      isExist: false,
      selectLoad: false,
      loginPageColor: "#1B487E",
      companyDataLocal: {},
      contactTypes: {},
      selectedContactType: "",
      activeWorkspace: "",
      botId: "",
      token: "",
      events: [
        "keyup",
        "keypress",
        "keydown",
        "click",
        "contextmenu",
        "dbclick",
        "mousedown",
        "mouseenter",
        "mouseleave",
        "mousemove",
        "mouseout",
        "mouseover",
        "mouseup",
        "error",
        "loadstart",
        "touchcancel",
        "touchend",
        "touchmove",
        "touchstart",
        "select",
        "unload",
        "scroll",
        "resize",
        "load",
        "beforeunload",
        "abort",
        "wheel",
      ],
      showWorkspaceRoleDropdown: false,
    };
  },
  computed: {
    ...mapGetters("navigationOpen", [
      "getIsOpen",
      "getIsCollapse",
      "getIsMobile",
    ]),
    ...mapGetters("auth", ["getAuthenticatedUser", "getActiveContactType"]),
    ...mapGetters("company", ["getContactLoginSlug"]),
    getLoginContactTypes() {
      if (this.getAuthenticatedUser?.contact_types) {
        return this.getAuthenticatedUser.contact_types.filter(
          (e) => e.has_login
        );
      }
      return [];
    },
    fetchAllContactTypes() {
      if (
        this.getAuthenticatedUser &&
        this.getAuthenticatedUser.contact_types &&
        this.getAuthenticatedUser.contact_types.length
      ) {
        return [...this.getAuthenticatedUser.contact_types];
      }
      return [];
    },
  },
  mixins: [UserHelper],
  async mounted() {
    if (this.getContactLoginSlug && this.getContactLoginSlug._id) {
      this.companyDataLocal = { ...this.getContactLoginSlug };
      if (this.getContactLoginSlug && this.getContactLoginSlug.logo) {
        this.companyDataLocal.logo = `${config.S3_BUCKET_URL}/${this.getContactLoginSlug.logo}`;
      }
      if (this.companyDataLocal?.button?.background) {
        this.loginPageColor = this.companyDataLocal.menubackground;
        document.documentElement.style.setProperty(
          "--primary-color",
          this.companyDataLocal.dialog_header_color
        );
        document.documentElement.style.setProperty(
          "--primary-contrast-color",
          this.companyDataLocal.dialog_header_text_color
        );
        document.documentElement.style.setProperty(
          "--topbar-text-color",
          this.companyDataLocal.topbar_text_color
        );
        document.documentElement.style.setProperty(
          "--sidemenu-background-color",
          this.companyDataLocal.sidemenu_background
        );
        document.documentElement.style.setProperty(
          "--sidemenu-text-color",
          this.companyDataLocal.sidemenu_text
        );
        document.documentElement.style.setProperty(
          "--icon-color",
          this.companyDataLocal.menu_icon_color
        );
        document.documentElement.style.setProperty(
          "--icon-hover-color",
          this.companyDataLocal.menu_icon_hover_color
        );
        document.documentElement.style.setProperty(
          "--tabs-color",
          this.companyDataLocal.tabs_color
        );
        document.documentElement.style.setProperty(
          "--tabs-hover-color",
          this.companyDataLocal.tabs_hover_color
        );
        const primaryColor = getComputedStyle(document.documentElement)
          .getPropertyValue("--primary-color")
          .trim();
        const lighterPrimaryColor = chroma(primaryColor).brighten(0.5).hex();
        const lighterbackgroundColor = chroma(primaryColor).brighten(1.0).hex();
        const darkerPrimaryColor = chroma(primaryColor).darken(0.5).hex();
        document.documentElement.style.setProperty(
          "--darker-primary-color",
          darkerPrimaryColor
        );
        document.documentElement.style.setProperty(
          "--lighter-primary-color",
          lighterPrimaryColor
        );
        document.documentElement.style.setProperty(
          "--lighter-background",
          lighterbackgroundColor
        );
        // document.documentElement.style.setProperty('--Hover-color-inputfield', this.companyInfo.menubackground);
        // document.documentElement.style.setProperty('--text-secondary-color', 'white');

        const secondaryColor = getComputedStyle(document.documentElement)
          .getPropertyValue("--secondary-color")
          .trim();

        const darkerSecondaryColor = chroma(secondaryColor).brighten(0.3).hex();

        document.documentElement.style.setProperty(
          "--darker-secondary-color",
          darkerSecondaryColor
        );
      }
    }
    this.setActiveContactType();
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    toggleWorkspaceRoleDropdown() {
      this.showWorkspaceRoleDropdown = !this.showWorkspaceRoleDropdown;
    },
    selectWorkspaceRole(contact) {
      this.activeWorkspace = contact.contact_type._id;
      this.changeWorkspaceRole(contact.contact_type._id);
      this.showWorkspaceRoleDropdown = false;
    },
    handleClickOutside(event) {
      const dropdownEl = this.$refs.workspaceRoleDropdown;
      if (dropdownEl && !dropdownEl.contains(event.target)) {
        this.showWorkspaceRoleDropdown = false;
      }
    },
    onIdle() {
      let timerInterval;
      Swal.fire({
        title: "Session Timed Out",
        html: `Your session has been automatically logged out due to inactivity`,
        timer: 4000,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        didOpen: () => {
          Swal.showLoading();
        },
        willClose: () => {
          clearInterval(timerInterval);
          this.logoutUser();
        },
      });
    },
    onRemind(time) {
      let timerInterval;
      Swal.fire({
        title: "",
        html: `Your session will automatically log out after ${time} seconds due to inactivity`,
        timer: 4000,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        didOpen: () => {
          Swal.showLoading();
        },
        willClose: () => {
          clearInterval(timerInterval);
          // this.logout();
        },
      });
    },

    //   this.loading = true;
    //   this.loadingText = "Loading Chat Bots ...";
    //   try {
    //     let response = await postAPICall("GET", "/bot/get-Bot");

    //     if (response && response.success && response.data?.chatBotDetails) {
    //       this.botAccounts = response.data?.chatBotDetails || [];

    //       const botIdRegex = /botId: '(.*?)'/;
    //       const tokenRegex = /token: '(.*?)'/;

    //         this.botId = this.botAccounts.match(botIdRegex)[1];
    //         this.token = this.botAccounts.match(tokenRegex)[1];
    //         localStorage.setItem("botId", this.botId);
    //         localStorage.setItem("token", this.token);
    //         const storedBotId = localStorage.getItem("botId");
    //         const storedToken = localStorage.getItem("token");

    //         if (storedBotId && storedToken) {
    //           window.bus.$emit("chatbot");
    //         } else {
    //           console.error("Failed to store botId or token in localStorage.");
    //         }
    //     }
    //   } catch (error) {
    //     console.error(error);
    //   } finally {
    //     this.loading = false;
    //   }
    // },
    getName(contact_type) {
            return contact_type.receiver_alias || contact_type.name;
    },
    setActiveContactType() {
      if (this.getActiveContactType?.contact_type?._id) {
        this.activeWorkspace = this.getActiveContactType.contact_type._id;
      }
    },
    async changeWorkspaceRole() {
      Swal.close();
      Swal.fire({
        title: "Are you sure?",
        text: "Are you sure to switch the application?",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
      }).then(async (result) => {
        if (result.isConfirmed) {
          let selectedWorkspace = (
            this.getAuthenticatedUser.contact_types || []
          ).find((e) => e?.contact_type?._id == this.activeWorkspace);
          if (selectedWorkspace) {
            await this.$store.commit(
              "auth/setActiveContactType",
              selectedWorkspace,
              {
                root: true,
              }
            );
            let user = this.getAuthenticatedUser;
            user["account_data_id"] = selectedWorkspace.account_data_id;
            user["contact_type"] = selectedWorkspace.contact_type
              ? selectedWorkspace.contact_type._id
                ? selectedWorkspace.contact_type._id
                : selectedWorkspace.contact_type
              : "";
            await this.$store.commit("auth/setAuthenticatedUser", user, {
              root: true,
            });

            await this.checkAndUpdateData();
          } else {
            this.resetWorkspace();
          }
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          this.resetWorkspace();
        }
      });
    },
    resetWorkspace() {
      let selectedWorkspace = (
        this.getAuthenticatedUser.contact_types || []
      ).find(
        (e) =>
          e?.contact_type?._id == this.getActiveContactType?.contact_type?._id
      );
      if (selectedWorkspace) {
        this.activeWorkspace = selectedWorkspace?.contact_type?._id;
      } else {
        this.handleLogoutInfo();
      }
    },
    async handleLogoutInfo() {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Due to inactivity for a prolonged period, your session has been automatically logged out for security purposes. Please feel free to log in again when you're ready!",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then((result) => {
        if (result.isConfirmed) {
          let timerInterval;
          Swal.fire({
            title: "",
            html: "Please wait ..... ",
            timer: 2000,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            didOpen: () => {
              Swal.showLoading();
            },
            willClose: () => {
              clearInterval(timerInterval);
              this.logoutUser();
            },
          });
        }
      });
    },

    sendMessageToParent() {
      const newState = !this.getIsOpen;
      this.isOpen = newState; // Sync local with Vuex state
      this.$store.commit("navigationOpen/setIsOpen", newState, {
        root: true,
      });
      this.$emit("open:sidebar", newState);
    },

    // sendMessageToParent() {
    //   this.isOpen = !this.isOpen;
    //   this.$store.commit("navigationOpen/setIsOpen", !this.getIsOpen, {
    //     root: true,
    //   });
    //   this.$emit("open:sidebar", this.isOpen);
    // },
    logoutUser() {
      localStorage.removeItem("botId");
      localStorage.removeItem("token");
      localStorage.removeItem("internal_chat_enabled");

      window.bus.$emit("chatbot");
      Swal.fire({
        title: "",
        html: "signing off....",
        timer: 3000,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        didOpen: () => {
          Swal.showLoading();
          const preservedLoginStartTime =
            localStorage.getItem("loginStartTime");
          localStorage.removeItem(config.APP_NAME + "_" + config.APP_VERSION);
          localStorage.clear();
          if (preservedLoginStartTime) {
            localStorage.setItem("loginStartTime", preservedLoginStartTime);
          }
          this.resetStore();
          this.$store.dispatch("auth/reset");
          this.$store.commit("company/resetCompaniesByEmail");
          clearDB(true);
        },
        willClose: () => {
          // if (this.companyDataLocal?.slug) {
          //   this.$router.push(
          //     `/ap/signin?company=${this.companyDataLocal.slug}`
          //   );
          // } else {
          this.$router.push("/signin/tenant");
          // }
        },
      });
      this.resetStore();
    },
    resetStore() {
      this.$store.commit("auth/resetAuthData");
      this.$store.commit("profile/resetProfileData");
      this.$store.commit("company/resetCompanyData");
      this.$store.commit("auth/resetAuthData", null, { root: true });
      this.$store.commit("company/resetCompanyData", null, { root: true });
      this.$store.commit("companyDocuments/resetCompanyDocumentsData", null, {
        root: true,
      });
      this.$store.commit("documentGroups/resetDocumentGroupsData", null, {
        root: true,
      });
      this.$store.commit(
        "documentCategories/resetDocumentCategoriesData",
        null,
        {
          root: true,
        }
      );

      this.$store.commit("companyBenefits/resetCompanyBenefitsData", null, {
        root: true,
      });
      this.$store.commit("companyTemplates/resetCompanyTemplatesData", null, {
        root: true,
      });
      this.$store.commit("offerLetter/resetOfferLetterData", null, {
        root: true,
      });
      this.$store.commit("employee/resetEmployeesData", null, {
        root: true,
      });
      this.$store.commit("configurableDocuments/resetConfigurableDocuments");

      this.$store.commit("standardDocumentConfig/reset");
      this.$store.commit("employeeData/reset");
      this.$store.commit("employeeDocuments/reset");
      this.$store.commit("workflowData/reset");
      this.$store.commit("workflows/reset");
      this.$store.commit("templatesData/reset");
      this.$store.commit("i9formDocuments/reset");
      this.$store.commit("authorizedRepresentatives/reset");
      this.$store.commit("employeeDocumentAuthorizedUsers/reset");
    },
    openProfile() {
      this.$router.push("/ap/profile");
    },
  },
};
</script>

<style lang="scss">
.top-navbar {
  position: fixed;
  height: 8vh !important;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: #1b487e;
  color: #ffffff;
  padding: 5px 10px;
  .top-navbar-left-menu {
    height: 6vh;
    display: flex;
    align-items: center;
    ul {
      display: flex;
      align-items: center;
      li {
        &:not(:last-child) {
          margin-right: 25px;
        }
        .company-logo {
          padding-top: 15px;
          padding-bottom: 10px;
          img {
            width: 100px;
          }
        }
      }
    }
  }
  .top-navbar-right-menu {
    .logout-dropdown {
      float: right;
      position: relative;
      display: flex;
      align-items: center;
      .alert-icon {
        position: relative;
        margin-right: 35px;
        .alert-count {
          position: absolute;
          top: -12px;
          right: -6px;
          span {
            background: #f754a2;
            font-size: 0.8em;
            border: 1px solid #f754a2;
            color: #ffffff;
            padding: 2px;
            width: 9px;
            height: 9px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
          }
        }
        img {
          width: 22px;
          margin-top: 5px;
        }
      }

      .top-search {
        .el-input__inner {
          border-radius: 3px;
          background: rgba(236, 245, 255, 0.1);
          font-size: 0.9rem;
          line-height: 2;
          width: calc(100% - 22px);
          border-color: rgba(236, 245, 255, 0.2);
          height: 38px;
          color: #ffffff;
          &:focus {
            border-color: #1b487e;
          }
        }
        .el-input__icon {
          line-height: 27px !important;
        }
      }

      .el-dropdown {
        font-size: 15px;
        padding-right: 0;
        display: flex;
        align-items: center;
        button {
          padding: 0;
          margin: 0;
          background: transparent;
          border: none;
        }
        &:hover {
          cursor: pointer;
        }
        .user-image {
          img {
            width: 36px;
            height: 36px;
            border-radius: 50%;
            margin-right: 10px;
            // margin-bottom: -20px;
          }
        }
        .icon-block {
          display: flex;
          align-items: center;
        }

        .icon-text {
          font-size: 1.1em;
          font-weight: 600;
          letter-spacing: 0.2px;
          color: var(--topbar-text-color);

          &:hover {
            color: var(--topbar-text-color);
          }

          .dropdown-arrow {
            img {
              width: 10px;
            }
          }
        }

        .user-profile-image {
          img {
            width: 25px;
          }
        }
      }
    }
  }
  .toggle-menu-animation {
    .hidden {
      visibility: hidden;
    }

    /** burger **/

    button {
      cursor: pointer;
    }

    /* remove blue outline */
    button:focus {
      outline: 0;
    }

    .burger-button {
      position: relative;
      height: 30px;
      width: 40px;
      display: block;
      z-index: 60;
      border: 0;
      border-radius: 0;
      background-color: transparent;
      pointer-events: all;
      transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
    }

    .burger-bar {
      background-color: #ffffff;
      position: absolute;
      top: 50%;
      right: 6px;
      left: 6px;
      height: 2px;
      width: auto;
      margin-top: -1px;
      transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
      opacity: 1;
    }

    .burger-bar--1 {
      -webkit-transform: translateY(-6px);
      transform: translateY(-8px);
    }

    .burger-bar--3 {
      transform: translateY(8px);
    }

    #burger.active .burger-button {
      transform: rotate(-180deg);
    }

    #burger.active .burger-bar--1 {
      transform: rotate(45deg);
    }

    #burger.active .burger-bar--2 {
      opacity: 0;
    }

    #burger.active .burger-bar--3 {
      transform: rotate(-45deg);
    }
  }
  .user-role {
    color: rgba($color: #ffffff, $alpha: 0.95);
    font-size: 0.8em;
    font-weight: 300;
  }
}
body.modal-open {
  height: 100vh;
  //overflow-y: hidden;
}
.top-navbar-right-menu {
  @media (max-width: 500px) {
    .user-image {
      &.profile-image {
        display: none;
      }
    }
  }
  .user-role {
    @media (max-width: 500px) {
      text-align: left;
      padding-left: 0px;
    }
    padding-left: 27px;
  }
}
.workspace {
  // margin-right: 30px;
}
</style>
<style lang="scss" scoped>
.active-option {
  background-color: #f0f8ff;
  font-weight: bold;
  color: #007bff;
}
.custom-dropdown {
  position: absolute;
  left: -100px;
  background: white;
  border: 1px solid #ccc;
  z-index: 999;
  margin-top: 5px;
  width: 170px;
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  max-height: 200px;
  overflow-y: scroll;
  scrollbar-width: thin;
}
.dropdown-option {
  padding: 8px 12px;
  cursor: pointer;
  color: #677788;
}
.dropdown-option:hover {
  background-color: #f0f0f0;
}
.dropdown-trigger {
  position: relative;
}
.custom-dropdown .dropdown-option.disabled {
  color: gray;
  pointer-events: none;
}

@media (max-width: 768px) {
  .top-navbar-left-menu ul {
    justify-content: center !important;
  }

  .top-navbar-left-menu .company-logo {
    text-align: center;
    width: 100%;
    padding-top: 8px;
    padding-bottom: 8px;
    img {
      max-width: 120px;
      margin: 0 auto;
      display: block;
    }
  }
}

@media (max-width: 768px) {
  .hamburger {
    display: none;
  }

  .mob {
    transform-origin: center top;

    z-index: 2011;

    position: fixed;

    top: -13px !important;

    width: 100%;

    height: 90vh;

    left: 0 !important;
  }
}

.circle-name {
  width: 36px;

  height: 36px;

  border-radius: 50%;

  background-color: white;

  border: 2px solid #409eff;

  color: black;

  font-weight: bold;

  font-size: 14px;

  text-align: center;

  line-height: 36px;

  cursor: pointer;
}

.circle-name.active {
  border-color: red;
}

.circle-name {
  width: 42px;

  height: 42px;

  border-radius: 50%;

  background-color: #fff;

  border: 2px solid #409eff;

  color: #000;

  font-weight: bold;

  font-size: 15px;

  text-align: center;

  line-height: 40px;
}

.mobile-dropdown-menu {
  padding: 0;

  .workspace-switcher {
    font-weight: 500;
    font-size: 14px;
    padding: 10px 15px;
    border-bottom: 1px solid #eee;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #333;

    &:hover {
      background-color: #f5f7fa;
    }
  }

  .mobile-workspace-options {
    background: #fff;
    border-bottom: 1px solid #eee;
    max-height: 200px;
    overflow-y: auto;
    padding: 0 5px;
    animation: fade-in 0.2s ease-in-out;

    .dropdown-option {
      padding: 10px 12px;
      font-size: 13.5px;
      color: #333;
      display: flex;
      align-items: center;
      cursor: pointer;
      border-radius: 4px;

      &:hover {
        background-color: #f0f9ff;
      }

      &.active-option {
        background-color: #e6f7ff;
        color: #409eff;
        font-weight: 600;
      }
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.mobile-dropdown-menu {
  padding: 0;
  width: 100vw;
  max-width: 100%;
  overflow: hidden;

  .dropdown-profile-block {
    display: flex;
    align-items: center;
    padding: 15px 16px;
    border-bottom: 1px solid #eee;

    .circle-name {
      width: 44px;
      height: 44px;
      background-color: #fff;
      border: 2px solid #409eff;
      border-radius: 50%;
      text-align: center;
      line-height: 42px;
      font-weight: bold;
      font-size: 16px;
      margin-right: 12px;
      color: #000;
    }

    .profile-name-block {
      flex: 1;

      .full-name {
        font-size: 15px;
        font-weight: bold;
        color: #333;
      }

      .active-workspace {
        font-size: 13px;
        color: #666;
        margin-top: 2px;
        display: flex;
        align-items: center;
      }
    }
  }

  .workspace-dropdown-container {
    padding: 10px 16px;

    .workspace-label {
      font-size: 13px;
      color: #888;
      margin-bottom: 5px;
      display: inline-block;
    }

    .workspace-select {
      width: 100%;
    }
  }

  .el-dropdown-item {
    padding: 12px 16px;
    display: flex;
    align-items: center;
    font-size: 14px;
  }
}

.app-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 6vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #1b487e;
  color: white;
  font-size: 13px;
  font-weight: 500;
  z-index: 999;
  box-shadow: 0 -1px 4px rgba(0, 0, 0, 0.1);
  text-align: center;

  .footer-content {
    width: 100%;
  }

  @media (max-width: 768px) {
    font-size: 12px;
    height: 5vh;
  }
}
</style>
